module.exports = __webpack_public_path__ + "static/nova-scotia-781234daefb0cbb87b98ac23d9c647bd.png";